import $ from 'cash-dom'
import { segment } from '../segment'
import { getPageProperties } from '../utils/page-properties'

const getContactLinkProperties = (element: HTMLElement) => {
  const properties: Record<string, any> = {
    category: 'link',
    action: 'Contact Link Clicked',
    ...getPageProperties(),
  }

  const href = $(element).attr('href') || ''

  if (href.startsWith('mailto:')) {
    properties['contact type'] = 'mailto'
    properties['click url'] = href
    properties['click text'] = href.replace('mailto:', '')
    properties.label = `${properties['click text']} | ${href}`
  } else if (href.startsWith('tel:')) {
    properties['contact type'] = 'tel'
    properties['click url'] = href
    properties['click text'] = href.replace('tel:', '')
    properties.label = `${properties['click text']} | ${href}`
  }

  return properties
}

const getClickProperties = (
  element: HTMLElement,
  eventType: string = 'CTA Clicked'
) => {
  const properties: Record<string, any> = {
    category: element.tagName.toLowerCase() === 'a' ? 'link' : 'button',
    action: eventType,
    ...getPageProperties(),
  }

  let rawText = $(element).text()?.trim() || $(element).attr('aria-label') || ''

  const clickText = rawText.replaceAll(/\s+/g, ' ').trim()
  if (clickText) {
    properties.click_text = clickText
  }

  let clickUrl =
    $(element).attr('href') ||
    $(element).attr('data-href') ||
    $(element).attr('data-url')

  if (
    !clickUrl &&
    element.tagName !== 'BUTTON' &&
    $(element).attr('type') !== 'submit'
  ) {
    clickUrl = window.location.href
  }

  if (clickUrl) {
    if (clickUrl.startsWith('/')) {
      clickUrl = window.location.origin + clickUrl
    } else if (!clickUrl.startsWith('http')) {
      clickUrl = window.location.origin + '/' + clickUrl
    }
    properties.click_url = clickUrl

    if (clickText) {
      properties.label = clickUrl ? `${clickText} | ${clickUrl}` : clickText
    }
  }

  const clickId =
    element.id ||
    $(element).attr('data-element') ||
    $(element).attr('data-track') ||
    element.className
      .split(' ')
      .find((cls: string) => cls && cls !== 'button') ||
    element.className.split(' ')[0] ||
    ''
  if (clickId) {
    properties.click_id = clickId
  }

  return properties
}

const isOutboundLink = (element: HTMLElement): boolean => {
  const href = $(element).attr('href') || ''
  if (
    !href ||
    href.startsWith('/') ||
    href.startsWith('#') ||
    href.startsWith('?')
  ) {
    return false
  }
  try {
    const linkUrl = new URL(href, window.location.origin)
    return linkUrl.hostname !== window.location.hostname
  } catch (error) {
    console.log('error', error)
    return false
  }
}

const initClickTracking = () => {
  $('a[href^="mailto:"], a[href^="tel:"]').on(
    'click',
    function (this: HTMLElement) {
      try {
        const properties = getContactLinkProperties(this)
        segment.track('Contact Link Clicked', properties)
      } catch (error) {
        console.error('Contact link tracking failed:', error)
      }
    }
  )

  $('a[href]').each(function () {
    const $this = $(this)
    const href = $this.attr('href') || ''

    if (/^(mailto:|tel:)/i.test(href)) return

    if (isOutboundLink(this)) {
      $this.on('click', () => {
        try {
          const properties = getClickProperties(this, 'outbound link clicked')
          segment.track('outbound link clicked', properties)
        } catch (error) {
          console.error('Outbound link tracking failed:', error)
        }
      })
    }
  })

  $('.analytics-click').on('click', function (this: HTMLElement) {
    try {
      const properties = getClickProperties(this)
      segment.track('CTA Clicked', properties)
    } catch (error) {
      console.error('Tracking link click failed:', error)
    }
  })
}

segment.ready(() => {
  initClickTracking()
})
